import { Component } from 'react';
import { Chart1 } from '../../components/chart1';
import { PieChart } from '../../components/Piechart';
import { VUTchart } from '../../components/VUTchart';
import { TripCostchart } from '../../components/TripCostchart';
import { DSSchart } from '../../components/DSSchart';
import { TTCBCchart } from '../../components/TTCBCchart';
import { TTCPCchart } from '../../components/TTCPCchart';
import { LIOchart } from '../../components/LIOchart';
import { VLLchart } from '../../components/VLLchart';
import { PCRPchart } from '../../components/PCRPchart';
import { PCRCchart } from '../../components/PCRCchart';
import { RKMchart } from '../../components/RKMchart';

export class DashboardPage extends Component<any, any> {
  constructor(props: any) {
    super(props)
    var accessObject: string = localStorage.getItem('WidgetAccess') || "[]";
    this.state = {
      widgetAccess: JSON.parse(accessObject),
    };
  }

  checkAccess(name: string) {
    var accessList = this.state.widgetAccess;

    if (accessList.includes(name)) {
      return true
    } else {
      return false
    }
  }

  render() {
    const hasTTC = this.checkAccess('TTC')
    const hasPCR = this.checkAccess('PCR')

    return (
      <div className='bi-dashboard'>
        <div className='row g-4'>
          {this.checkAccess('OTA') && (
            <div className='col-12'>
              <Chart1 />
            </div>
          )}

          {this.checkAccess('OTD') && (
            <div className='col-12'>
              <PieChart />
            </div>
          )}

          {this.checkAccess('VUT') && (
            <div className='col-12'>
              <VUTchart />
            </div>
          )}

          {this.checkAccess('TCS') && (
            <div className='col-12'>
              <TripCostchart />
            </div>
          )}

          {this.checkAccess('DSS') && (
            <div className='col-12'>
              <DSSchart />
            </div>
          )}

          {hasTTC && (
            <>
              <div className='col-12'>
                <TTCBCchart />
              </div>
              <div className='col-12'>
                <TTCPCchart />
              </div>
            </>
          )}

          {this.checkAccess('VLL') && (
            <div className='col-12'>
              <VLLchart />
            </div>
          )}

          {this.checkAccess('LIO') && (
            <div className='col-12'>
              <LIOchart />
            </div>
          )}

          {hasPCR && (
            <>
              <div className='col-12 col-xl-6'>
                <PCRPchart />
              </div>
              <div className='col-12 col-xl-6'>
                <PCRCchart />
              </div>
            </>
          )}

          {this.checkAccess('RKM') && (
            <div className='col-12'>
              <RKMchart />
            </div>
          )}
        </div>
      </div>
    )
  }
}

function DashbaordWrapper() {
  return (
    <div className="container-fluid px-4 px-lg-6 py-4">
      <DashboardPage />
    </div>
  );
}

export default DashbaordWrapper;
